import React, { useState } from "react";
import styled from "styled-components";
import { MdLockOutline } from "react-icons/md";
import CredentialModal from "./CredentialModal";

export default function DemoCredentialButton({ credentials }) {
  const [showModal, setShowModal] = useState(false);

  if (!credentials) return null;

  return (
    <>
      <CredentialButton onClick={() => setShowModal(true)}>
        <MdLockOutline style={{ marginRight: '5px', fontSize: '18px' }} /> View Credentials
      </CredentialButton>
      <CredentialModal 
        showModal={showModal} 
        setShowModal={setShowModal} 
        credentials={credentials} 
      />
    </>
  );
}

const CredentialButton = styled.button`
  background-color: #f3f4f6;
  color: #4b5563;
  border: 1px solid #e5e7eb;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  margin-right: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);

  &:hover {
    background-color: #e5e7eb;
    transition: all 0.2s ease-in-out;
  }
  
  @media (max-width: 600px) {
    margin-right: 0;
    margin-bottom: 15px;
  }
`;
